import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  icon: {
    color: "#ffffff",
    filter: `drop-shadow(0px 0px 1px ${theme.palette.primary.main})`,
    transition: "background-color 0.1s, transform 0.1s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  modalControls: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginTop: "auto",
      flexDirection: "column-reverse",
    },
  },
  previewImage: {
    aspectRatio: "1 / 1",
    maxHeight: 400,
    "& > img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: 200,
    },
  },
}));
